export enum FilterDisplay{
  /**
   * Siempre mostrar todos los nombres.
   */
  LABEL = 'label',
  /**
   * Siempre mostrar todos los nombres.
   */
  LABEL_PLUS_COUNT = 'label_count',
  /**
   * Siempre mostrar chips.
   */
  CHIPS = 'chips',
  /**
   * Siempre mostrar el número de seleccionados.
   */
  COUNT = 'count',
  /**
   * Inteligente.
   *
   * 1 seleccionado -> nombre
   * Más de 1 -> contador
   */
  AUTO = 'auto'
}

export interface FilterDisplayConfig {

  /**
   * Estrategia de presentación.
   */
  mode: FilterDisplay;

  /**
   * Placeholder cuando no hay selección.
   */
  placeholder?: string;

  /**
   * Cantidad máxima de elementos
   * visibles antes de resumir.
   */
  maxLabels?: number;

}